import { useQuery } from "react-query";
import { fetchProductBase } from "../services/product/product.api";

export function useProductBase(productId?: string) {
  const query = useQuery(
    ["product", productId],
    () => fetchProductBase(productId), // <- this should return a single product
    {
      enabled: !!productId,
    }
  );

  return query;
}
